import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from } from '@helpers/media';
import { h2 } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --bgColor: transparent;
  --fgColor: ${brand.white};
  --itemGutter: 16px;
  --visibleItems: 4;

  color: var(--fgColor);
  overflow-x: hidden;
  position: relative;

  ${SectionWrapperStyles.SiteWide} {
    position: relative;
  }
`;
const TitleArea = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${fluid(16, 24)};
`;
const Title = styled.h2 `
  ${h2};
  margin-bottom: 0;
`;
const Grid = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${fluid(16, 32)};

  @media ${from(Device.Tablet)} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${from(Device.DesktopSmall)} {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const Item = styled.li `
  display: block;
`;
const OurPeopleCarouselStyles = {
    Container,
    Grid,
    Item,
    Title,
    TitleArea,
};
export default OurPeopleCarouselStyles;
